module.exports = __webpack_public_path__ + "img/rossignol.bc959771.svg";